import type { TvProgramme } from '@/types/tvTypes'

/**
 * Builds a stable programme identifier for "this Channel + TV Programme".
 * Used to associate threads with TV listings and to look up existing threads
 * for the same programme (direct comment from TV flow).
 *
 * Format: channelId + "|" + normalized title + "|" + start ISO string.
 * Normalization: trim title, collapse internal spaces (no leading/trailing).
 */
export function buildProgrammeIdentifier(programme: TvProgramme): string {
  const channelId = programme.channelId
  const title = programme.title.trim().replace(/\s+/g, ' ')
  const start = programme.start.toISOString()
  return `${channelId}|${title}|${start}`
}

/**
 * Parses channel id from a programme identifier (for lookup).
 * Returns null if the identifier format is invalid.
 */
export function parseChannelIdFromIdentifier(programmeIdentifier: string): string | null {
  const parts = programmeIdentifier.split('|')
  return parts.length >= 1 ? parts[0] : null
}
